import { useCallback } from 'react'
import { InputTableHookProps } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { TableWithoutVirtualListingRowProps } from '../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { addAntiUnsaveElement } from '../../../../../utils/reducers/reduxDispatch'
import { OnChangeOrderAddProduct } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput/types'
import { useOrderLayoutTableLogic } from '../../OrderLayout/OrderTable/useOrderLayoutTableLogic'

interface OrderSellTicketLayoutProps extends InputTableHookProps { }

const useSellTicketLayoutTableLogic = ({ completeData, inputTableURLs, getCompleteData, ...rest }: OrderSellTicketLayoutProps) => {
    const myAddExtraStyles = useCallback((props: TableWithoutVirtualListingRowProps) => {
        if (props.style && props.rowData['Product.featuredColor']){
            props.style.color = props.rowData['Product.featuredColor']
        }
    }, [])

    const myOnChangeAdd: OnChangeOrderAddProduct = useCallback(async (product) => {
        await addAntiUnsaveElement(['sellTicket', '{}'])
        const newProduct = await twinFetchPostJSON(inputTableURLs.createData[0], { ...inputTableURLs.createData[1], ProductId: product.id, SuperProductParentId: product.ProductId, uniqueNumber: product.unique_number })
        await getCompleteData(newProduct.OrderId, true)
        //@ts-ignore
        document.querySelector('.add_product_row.input_table_header_row')?.click()
    }, [getCompleteData, inputTableURLs])
    
    return useOrderLayoutTableLogic({ ...rest, completeData, getCompleteData, inputTableURLs, customFunctions: { onChangeAdd: myOnChangeAdd }, myAddExtraStyles })
}

export default useSellTicketLayoutTableLogic